/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import './forms.css';
import ButtonText from '../buttons/button-text';

class ResumeEditExperience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      section: props.section,
      resume: props.resume,
      skills: props.resume.skills || [],
      firstRun: props.firstRun,
      loading: false,
      buttonDisabled: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ loading: props.loading });
  }

  handleInputChange(index, event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const { skills, section } = this.state;
    skills[index] = {
      [name]: value,
      level: section,
    };

    this.setState(
      (prevState) => ({
        skills,
        buttonDisabled: false,
      }),
      () => {}
    );
  }

  handleSaveResumeChange(event) {
    event.preventDefault();
    const { skills } = this.state;
    const { resume } = this.state;
    resume.skills = skills;
    this.props.onResumeUpdated(resume);
  }

  render() {
    const listOfKnowledgeItems = this.state.skills.map((skill, index) => {
      if (skill.level === this.state.section) {
        return (
          // eslint-disable-next-line jsx-a11y/label-has-associated-control
          <label className="jh-form-label" key={index}>
            <h2>{this.state.section}</h2>
            <p className="jh-input-helper-text">
              Enter something you have a lot of experience with. Such as
              &quot;10+ Years project management.&quot;
            </p>
            <div className="jh-input-container">
              <input
                required
                type="text"
                placeholder="5+ years customer service"
                name="name"
                value={skill.name}
                onChange={this.handleInputChange.bind(this, index)}
              />
            </div>
          </label>
        );
      }
      return '';
    });

    return (
      <div className="jh-edit-form-container">
        <h1 className="jh-edit-form-heading">{this.state.section}</h1>
        <form
          className="jh-edit-form"
          onSubmit={this.handleSaveResumeChange.bind(this)}
        >
          <p className="jh-edit-form-details">
            This is where we will list out the most relevent experience you have
            for the position you are applying for. Top 5 experience items.
          </p>
          <div className="jh-form-group">{listOfKnowledgeItems}</div>
          <div className="jh-form-button-container">
            {this.state.firstRun === true && (
              <button disabled={this.state.buttonDisabled} type="submit">
                <ButtonText
                  loading={this.state.loading}
                  type="success"
                  text="SAVE AND CONTINUE"
                />
              </button>
            )}
            {this.state.firstRun === false && (
              <button disabled={this.state.buttonDisabled} type="submit">
                <ButtonText
                  loading={this.state.loading}
                  type="success"
                  text="SAVE EXPERIENCES"
                />
              </button>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export default ResumeEditExperience;
